import { styled } from '@ringcentral/juno';
import { useProximaNovaMedium, FontWeight } from '@/core/sc';

export const Title = styled.div`
  ${useProximaNovaMedium};
  margin-bottom: 24px;
  line-height: 24px;
  font-size: 16px;
  font-weight: ${FontWeight.regular};
  color: #282829;
`;
